import { Pipe, PipeTransform } from "@angular/core";
import NamedContact from "../../models/named-contact";

@Pipe({
  name: "lastFirstPatientName",
})
export class LastFirstPatientName implements PipeTransform {
  transform(value: NamedContact, ...args: any[]): any {
    if (!(value && value.firstName && value.lastName)) return;

    let name = `${value.lastName}, ${value.firstName}`;

    if (value.middleInitial) {
      name += ` ${value.middleInitial}.`;
    }

    if (value.suffix && value.suffix != "Other" && value.suffix != "None") {
      name += ` ${value.suffix}`;
    }

    return name;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/last-first-patient-name.ts